export default __webpack_public_path__ + "static/media/emptyImg.336e8421.png";